import * as tslib_1 from "tslib";
import { FirmlyApprovedService } from './../../../shared/services/firmly-approved/firmly-approved.service';
import { PopupService } from './../../../shared/services/popup/popup.service';
import { OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { OpEnum } from 'src/app/shared/enums/op.enum';
import { AbreCuentasService } from 'src/app/shared/services/abre-cuentas/abre-cuentas.service';
import { BitacoraService } from 'src/app/shared/services/bitacora/bitacora.service';
import { CopyService } from 'src/app/shared/services/copies/copy.service';
import { HeaderService } from 'src/app/shared/services/header/header.service';
import { NavigationService } from 'src/app/shared/services/navigation/navigation-onboarding.service';
import { ParametersService } from 'src/app/shared/services/parameters/parameters.service';
import { ProductsService } from 'src/app/shared/services/products/products.service';
import { BioCatchService } from 'src/app/shared/services/external/biocatch/biocatch.service';
import { TaggingService } from 'src/app/shared/services/tagging/tagging.service';
import { EVENT } from 'src/app/shared/constants/dali.constants';
import { RequestService } from 'src/app/shared/services/request/request-onboarding.service';
import { CaptureService } from 'src/app/shared/services/capture/capture.service';
import { PostValidateService } from 'src/app/shared/services/post-validate/post-validate.service';
import { BUSINESS_CONST } from 'src/app/shared/constants/business.constants';
import { IdentificationService } from 'src/app/shared/services/identification/identification.service';
import { ValidationHelperService } from 'src/app/shared/services/helpers/validation-helper.service';
import { ProductLoaderService } from 'src/app/shared/services/product-loader/product-loader.service';
import { ChannelCommunicatorService } from 'src/app/shared/services/communicator/channel-communicator/channel-communicator.service';
import { CHANNEL } from 'src/app/shared/constants/channel.constants';
// import { DataAbrecuenta } from './data-mock';
var LOAN_PRODUCT = 'loan';
var RequestComponent = /** @class */ (function () {
    function RequestComponent(copyService, navigationService, bitacoraService, formBuilder, parameterService, headerService, abreCuentasService, productsService, bioCatchService, taggingService, requestService, captureService, postValidate, identificationService, validationHelperService, productLoaderService, channelCommunicatorService, popupService, firmlyApprovedService) {
        this.copyService = copyService;
        this.navigationService = navigationService;
        this.bitacoraService = bitacoraService;
        this.formBuilder = formBuilder;
        this.parameterService = parameterService;
        this.headerService = headerService;
        this.abreCuentasService = abreCuentasService;
        this.productsService = productsService;
        this.bioCatchService = bioCatchService;
        this.taggingService = taggingService;
        this.requestService = requestService;
        this.captureService = captureService;
        this.postValidate = postValidate;
        this.identificationService = identificationService;
        this.validationHelperService = validationHelperService;
        this.productLoaderService = productLoaderService;
        this.channelCommunicatorService = channelCommunicatorService;
        this.popupService = popupService;
        this.firmlyApprovedService = firmlyApprovedService;
        this.list_multi = [];
        this.statusValidation = false;
        this.checkboxValidation = false;
        this.select_products = [];
        this.array = [];
        this.product = {};
        this.loan = false;
        this.personal = false;
        this.cardCredit = false;
        this.rotary = false;
        this.resListChecked = [];
        this.jsonResProduct = [];
        this.headerService.show(true, true, true);
        this.channelId = this.channelCommunicatorService.getChannelId();
    }
    RequestComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var products, _a, _b, row;
            var e_1, _c, _d;
            return tslib_1.__generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        this.sendTagging('init');
                        this.list_multi = this.parameterService.getSetting(OpEnum.LIST_MULTI);
                        if (this.channelCommunicatorService.getChannelId() !== CHANNEL.PORTALO.CODE) {
                            this.list_multi.map(function (m) {
                                if (m.flow === 'loan') {
                                    m.show = false;
                                }
                            });
                        }
                        if (this.abreCuentasService.getUserJemelii()) {
                            console.log(this.list_multi);
                            this.list_multi.map(function (m) {
                                if (m.flow === 'revolvingCredit' ||
                                    m.flow === 'freeInvestment' ||
                                    m.value === 'Créditos') {
                                    m.show = false;
                                }
                            });
                        }
                        products = this.abreCuentasService.getPostlogin()
                            ? this.parameterService.getSetting(OpEnum.ABRE_CUENTAS_PRODUCTS_CE)
                            : this.parameterService.getSetting(OpEnum.ABRE_CUENTAS_PRODUCTS);
                        this.multi = products;
                        this.initForm();
                        // VALIDACION SI EXISTEN PRODUCTOS YA SELECCIONADOS
                        if (this.abreCuentasService.getProductsSelects().length > 0) {
                            try {
                                for (_a = tslib_1.__values(this.abreCuentasService.getProductsSelects()), _b = _a.next(); !_b.done; _b = _a.next()) {
                                    row = _b.value;
                                    if (row.status) {
                                        this.formGroup.patchValue((_d = {},
                                            _d[row.flow] = row.status,
                                            _d));
                                    }
                                }
                            }
                            catch (e_1_1) { e_1 = { error: e_1_1 }; }
                            finally {
                                try {
                                    if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                                }
                                finally { if (e_1) throw e_1.error; }
                            }
                        }
                        return [4 /*yield*/, this.validateFirmlyApprovedOffersForPopup()];
                    case 1:
                        _e.sent();
                        if (this.hasFirmlyApprovedOffer) {
                            this.popupService.showPopup();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    RequestComponent.prototype.initForm = function () {
        var _this = this;
        this.formGroup = this.formBuilder.group(this.createForm());
        this.formGroup.valueChanges.subscribe(function (res) {
            _this.validData(res);
        });
    };
    RequestComponent.prototype.validateFirmlyApprovedOffersForPopup = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var channelsAllowed, offerData;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        channelsAllowed = [
                            CHANNEL.PORTALPN.CODE,
                            CHANNEL.SUPERAPP.CODE,
                        ];
                        if (!this.abreCuentasService.getPostlogin() || !channelsAllowed.includes(this.channelId)) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.firmlyApprovedService.getProductsOffer()];
                    case 1:
                        _a.sent();
                        this.firmlyApprovedOffers = this.firmlyApprovedService.getProductsFirmlyApproved();
                        if (this.firmlyApprovedOffers && this.firmlyApprovedOffers.length > 0) {
                            offerData = {
                                offerId: String(this.firmlyApprovedOffers[0].id),
                                offerType: this.firmlyApprovedOffers[0].offerType,
                            };
                            console.warn('firmlyApproved offerData:', offerData);
                            this.firmlyApprovedService.setOffer_Channel(offerData);
                            this.hasFirmlyApprovedOffer = true;
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Se retira metodo ya que en la linea 125 a la 129 hace la misma función
     */
    // checkChecked() {
    //   if (this.formGroup.controls['freeInvestment'].value) {
    //     this.loan = true;
    //     this.formGroup.controls['loan'].disable();
    //   } else {
    //     this.formGroup.controls['loan'].enable();
    //   }
    //   if (this.formGroup.controls['loan'].value) {
    //     this.loan = true;
    //     this.formGroup.controls['freeInvestment'].disable();
    //   } else {
    //     this.formGroup.controls['freeInvestment'].enable();
    //   }
    // }
    RequestComponent.prototype.opacityChange = function (clas) {
        if (clas === 'loan' && this.formGroup.controls['freeInvestment'].value) {
            return 'loan';
        }
        if (clas === 'freeInvestment' && this.formGroup.controls['loan'].value) {
            return 'freeInvestment';
        }
    };
    RequestComponent.prototype.validData = function (data) {
        this.array = [];
        this.statusValidation = false;
        var _loop_1 = function (row) {
            var object = this_1.list_multi
                .filter(function (item) { return item.flow; })
                .filter(function (item) { return item.flow === row; })[0];
            if (data[row]) {
                object.status = data[row];
                this_1.array.push(object);
                this_1.statusValidation = true;
            }
        };
        var this_1 = this;
        for (var row in data) {
            _loop_1(row);
        }
        // validation loan
        if ((data.loan || data.freeInvestment) &&
            this.channelCommunicatorService.getChannelId() === CHANNEL.PORTALO.CODE) {
            this.loan = true;
        }
        else if (!data.loan && !data.freeInvestment) {
            this.loan = false;
        }
        if (data.freeInvestment) {
            this.personal = true;
        }
        else {
            this.personal = false;
        }
        // Validation +3 checkbox
        if (this.array.length === 3) {
            this.checkboxValidation = true;
        }
        else {
            this.checkboxValidation = false;
        }
    };
    RequestComponent.prototype.next = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var products, sendExtras;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.beNormalized = false;
                        this.haveLoan =
                            this.array.filter(function (product) { return product.flow === LOAN_PRODUCT; }).length > 0;
                        this.abreCuentasService.setHaveloan(this.haveLoan);
                        this.abreCuentasService.setProductsSelects(this.array);
                        this.abreCuentasService.setFlowStructure(this.abreCuentasService.getAbreCuentasModel().flowStructure);
                        return [4 /*yield*/, this.validategetAgreementsOffersLoan()];
                    case 1:
                        _a.sent();
                        console.log('ARRAY---', this.array);
                        if (!(this.array.length > 1)) return [3 /*break*/, 5];
                        this.viewMulti();
                        this.multi = this.multi.filter(function (product) { return product.product_type === 'multi'; });
                        this.abreCuentasService.setproductSelected(this.multi[0]);
                        if (!(this.abreCuentasService.getPostlogin() &&
                            this.abreCuentasService.getproductSelected().product_type ===
                                BUSINESS_CONST.MULTI)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.callClientExistInformationService()];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        this.navigateLoanProduct();
                        _a.label = 4;
                    case 4: return [3 /*break*/, 8];
                    case 5:
                        if (!(this.array.length === 1)) return [3 /*break*/, 8];
                        this.array[0].prioritize = '1';
                        this.array[0].prioritizeForClient = '1';
                        this.abreCuentasService.setProductsSelects(this.array);
                        this.abreCuentasService.setMultiView(false);
                        products = this.abreCuentasService.getPostlogin()
                            ? this.parameterService.getSetting(OpEnum.ABRE_CUENTAS_PRODUCTS_CE)
                            : this.parameterService.getSetting(OpEnum.ABRE_CUENTAS_PRODUCTS);
                        this.product = products.filter(function (fil) { return fil.flow === _this.array[0].flow; })[0];
                        this.abreCuentasService.setproductSelected(this.product);
                        if (!this.abreCuentasService.getPostlogin()) return [3 /*break*/, 7];
                        return [4 /*yield*/, this.callClientExistInformationService(this.array[0].code)];
                    case 6:
                        _a.sent();
                        return [3 /*break*/, 8];
                    case 7:
                        if (this.array[0].product_type === BUSINESS_CONST.PRODUCT_TYPE_LOAN &&
                            !this.beNormalized) {
                            this.navigationService.nextStep('203');
                        }
                        else {
                            this.navigationService.nextStep(this.array[0].code);
                        }
                        _a.label = 8;
                    case 8:
                        sendExtras = {
                            object: 'transactionProductDetails',
                            value: this.addProductExtra(),
                            pageValue: 'request',
                        };
                        this.sendTagging('next', 'bottom', '3', sendExtras);
                        this.saveBitacoraProducts();
                        return [2 /*return*/];
                }
            });
        });
    };
    RequestComponent.prototype.sendTagging = function (value, position, event, extras) {
        var page = '25';
        this.taggingService.sendTaggValues(value, page, position, event, extras);
    };
    RequestComponent.prototype.addProductExtra = function () {
        var _this = this;
        var extras = '';
        var extrasProduct = {
            TCR: function () { return 'TarjetaCredito'; },
            ORD: function () { return 'CreditoPersonal'; },
            CRP: function () { return 'CreditoRotativo'; },
        };
        this.array.forEach(function (product, index) {
            extras += extrasProduct[product.product_code]();
            if (index < (_this.array.length - 1)) {
                extras += ',';
            }
        });
        console.log('Extras Taggeo: ', extras);
        return extras;
    };
    RequestComponent.prototype.saveBitacoraProducts = function () {
        var _this = this;
        this.array.forEach(function (element) {
            _this.bitacoraService.saveDataInBitacora(element.product_type);
        });
    };
    RequestComponent.prototype.navigateLoanProduct = function () {
        switch (this.haveLoan) {
            case true:
                this.navigationService.nextStep('202');
                break;
            default:
                this.navigationService.nextStep('200');
                break;
        }
    };
    RequestComponent.prototype.validategetAgreementsOffersLoan = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var loanFilter;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        loanFilter = this.array.filter(function (item) { return item.flow === 'loan'; });
                        if (!(loanFilter.length > 0)) return [3 /*break*/, 2];
                        // return true;
                        return [4 /*yield*/, this.productsService
                                .getAgreementsOffersLoan()
                                .then(function (data) {
                                console.log(data);
                                return true;
                            })
                                .catch(function (error) { return console.log(error); })];
                    case 1:
                        // return true;
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2: return [2 /*return*/, false];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    RequestComponent.prototype.viewMulti = function () {
        this.abreCuentasService.setMultiView(true);
    };
    RequestComponent.prototype.closeApp = function () {
        var bitacoraEvent = "exit_process";
        this.bitacoraService.saveDataInBitacora(bitacoraEvent);
        this.navigationService.loadExitScreen = true;
    };
    RequestComponent.prototype.createForm = function () {
        var e_2, _a;
        var values = {};
        try {
            for (var _b = tslib_1.__values(this.list_multi), _c = _b.next(); !_c.done; _c = _b.next()) {
                var field = _c.value;
                if (field.flow) {
                    values[field.flow] = [''];
                    values[field.flow].push(Validators.required);
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
        return values;
    };
    /*
     * Función para ir a los detalles del producto seleccionado
     *
     * *Go to selected product details function*
     *
     * @param {IProductsModel} product
     * @param {string} _label
     */
    RequestComponent.prototype.goToProductDetails = function (productFlow, _label) {
        this.abreCuentasService.setProductsSelects(this.array);
        var products = this.abreCuentasService.getPostlogin()
            ? this.parameterService.getSetting(OpEnum.ABRE_CUENTAS_PRODUCTS_CE)
            : this.parameterService.getSetting(OpEnum.ABRE_CUENTAS_PRODUCTS);
        this.product = products.filter(function (fil) { return fil.flow === productFlow; })[0];
        this.selectProduct(this.product, 'nextToProductDetails');
        var category = {
            module: 'body',
            type: 'link',
            position: 'bottom',
        };
        var productCamelize = this.navigationService.camelize(this.product.name);
        var CustomLabel = _label + " | " + productCamelize;
        this.pageTagEvent('1', category, 'click', CustomLabel);
    };
    /**
     * Función que guarda la información del producto seleccionado
     *
     * *Funtion that saves selected product infomation*
     *
     * @param {IProductsModel} product
     * @param {string} advance
     */
    RequestComponent.prototype.selectProduct = function (product, advance) {
        var _this = this;
        this.productsService
            .assignProductType(product)
            .then(function () {
            var biocatchInfo = _this.bioCatchService.getBiocatchInfo();
            _this.abreCuentasService.setproductSelected(product);
            if (_this.abreCuentasService.getIsPortal()) {
                _this.bitacoraService.saveDataInBitacora('Chanel_131_Portal');
            }
            _this.bitacoraService.saveDataInBitacora(product.product_type);
            if (!!biocatchInfo.ipGeoCity && !!biocatchInfo.ipGeoCountry) {
                var bitacoraEvent = "geo_biocatch_" + biocatchInfo.ipGeoCity + "_" + biocatchInfo.ipGeoCountry;
                _this.bitacoraService.saveDataInBitacora(bitacoraEvent);
            }
            _this[advance.toString()]();
        })
            .catch(function () { return _this.navigationService.navigateToGeneralInformation('500'); });
    };
    RequestComponent.prototype.pageTagEvent = function (eventNumber, category, customAction, customLabel) {
        var tagPageName = this.navigationService.getCurrentStep().tag_name;
        var event = {
            category: {
                module: EVENT.customCategory.module[category.module],
                type: EVENT.customCategory.type[category.type],
                position: EVENT.customCategory.position[category.position],
            },
            action: EVENT.customAction[customAction],
            label: customLabel
                ? customLabel
                : EVENT[tagPageName + "E" + eventNumber + "customLabel"],
        };
        this.taggingService.pageTagEvent(event);
    };
    /*
     * Función para ir a los detalles del producto seleccionado, se utiliza el código del producto
     *
     * Function that goes to the selected product details, it uses the product code
     */
    RequestComponent.prototype.nextToProductDetails = function () {
        switch (this.product.code) {
            case '205':
                this.navigationService.nextStep('951');
                break;
            default:
                this.navigationService.nextStep('952');
                break;
        }
    };
    RequestComponent.prototype.callPerformPco = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.productLoaderService.show(this.copyService.copies.show_load_pco);
                        return [4 /*yield*/, this.captureService
                                .performIncomes()
                                .then(function (income) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                var _this = this;
                                return tslib_1.__generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            if (income !== '200') {
                                                this.navigationService.navigateToGeneralInformation('107');
                                                return [2 /*return*/];
                                            }
                                            return [4 /*yield*/, this.captureService
                                                    .performPco()
                                                    .then(function (res) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                                    var _this = this;
                                                    return tslib_1.__generator(this, function (_a) {
                                                        switch (_a.label) {
                                                            case 0:
                                                                if (res !== '200') {
                                                                    this.navigationService.navigateToGeneralInformation('107');
                                                                    return [2 /*return*/];
                                                                }
                                                                return [4 /*yield*/, this.abreCuentasService.sleep(50000)];
                                                            case 1:
                                                                _a.sent();
                                                                return [4 /*yield*/, this.captureService
                                                                        .getChannelComunicator()
                                                                        .then(function (code) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                                                        return tslib_1.__generator(this, function (_a) {
                                                                            if (code === '107' ||
                                                                                code === '121' ||
                                                                                code === '130' ||
                                                                                code === '129' ||
                                                                                code === '124' ||
                                                                                code === '127') {
                                                                                this.navigationService.navigateToGeneralInformation(code);
                                                                            }
                                                                            else {
                                                                                if (code === '17') {
                                                                                    this.beNormalized = true;
                                                                                    if (this.abreCuentasService.viewOptionMultiProduct) {
                                                                                        this.loanProductFilter();
                                                                                    }
                                                                                    else {
                                                                                        this.navigationService.navigateToGeneralInformation('LIBERROR');
                                                                                        this.bitacoraService.saveDataInBitacora('Normalization_yes');
                                                                                    }
                                                                                }
                                                                            }
                                                                            this.productLoaderService.hide();
                                                                            return [2 /*return*/];
                                                                        });
                                                                    }); })
                                                                        .catch(function () {
                                                                        return _this.navigationService.navigateToGeneralInformation('107');
                                                                    })];
                                                            case 2:
                                                                _a.sent();
                                                                return [2 /*return*/];
                                                        }
                                                    });
                                                }); })
                                                    .catch(function () {
                                                    return _this.navigationService.navigateToGeneralInformation('107');
                                                })];
                                        case 1:
                                            _a.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            }); })
                                .catch(function () { return _this.navigationService.navigateToGeneralInformation('107'); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    RequestComponent.prototype.loanProductFilter = function () {
        var _this = this;
        this.productsSelectedMulti.forEach(function (products) {
            if (products.product_type === BUSINESS_CONST.PRODUCT_TYPE_LOAN) {
                // tslint:disable-next-line: no-shadowed-variable
                _this.array = _this.productsSelectedMulti.filter(function (products) {
                    return products.product_type !== BUSINESS_CONST.PRODUCT_TYPE_LOAN;
                });
                _this.abreCuentasService.setProductsSelects(_this.array);
            }
        });
    };
    RequestComponent.prototype.callClientExistInformationService = function (code) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var documentInfo, parms;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        documentInfo = this.abreCuentasService.getDocumentInfo();
                        parms = {
                            data: {
                                document: {
                                    number: documentInfo.document_number,
                                    type: documentInfo.document_type,
                                },
                            },
                        };
                        return [4 /*yield*/, this.identificationService
                                .getClientInformation(parms)
                                .then(function (resp) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                return tslib_1.__generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            if (!(resp.status === 200)) return [3 /*break*/, 3];
                                            this.abreCuentasService.setCustomerData(resp.body.data);
                                            this.validationHelperService.setCustomerDataClient();
                                            if (!this.haveLoan) return [3 /*break*/, 2];
                                            return [4 /*yield*/, this.callPerformPco()];
                                        case 1:
                                            _a.sent();
                                            this.navigationService.nextStep('202');
                                            return [3 /*break*/, 3];
                                        case 2:
                                            if (this.abreCuentasService.viewOptionMultiProduct) {
                                                this.navigationService.nextStep('200');
                                            }
                                            else {
                                                this.navigationService.nextStep(code);
                                            }
                                            _a.label = 3;
                                        case 3: return [2 /*return*/];
                                    }
                                });
                            }); })
                                .catch(function () { return _this.navigationService.navigateToGeneralInformation('512'); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return RequestComponent;
}());
export { RequestComponent };
